import { ApiSmpArtGallery } from "@smp/api";
import { Await } from "@smp/utils";
import { useInfiniteQuery } from "react-query";
import { UseInfiniteQueryOptions } from "react-query/types/react/types";

import { useContextApp } from "@/screens/app/context/app";

const KEY_POLOTNO_BRAND_BOOKS = "polotno.brand_books";

export const useQueryPolotnoBrandBooks = (
  options?: Omit<
    UseInfiniteQueryOptions<
      Await<ReturnType<typeof ApiSmpArtGallery.BrandBook.list>>
    >,
    "queryKey" | "queryFn" | "getNextPageParam"
  >,
) => {
  const {
    state: { organizationId },
  } = useContextApp();

  return useInfiniteQuery<
    Await<ReturnType<typeof ApiSmpArtGallery.BrandBook.list>>
  >(
    [KEY_POLOTNO_BRAND_BOOKS, { organizationId }],
    ({ pageParam }) => ApiSmpArtGallery.BrandBook.list(pageParam),
    {
      getNextPageParam: (response) => response.next || undefined,

      ...(options || {}),
    },
  );
};

useQueryPolotnoBrandBooks.KEY = KEY_POLOTNO_BRAND_BOOKS;
